$(document).ready(function() {
  const currentUrl = window.location.href;
  if (currentUrl.includes('/products/')) {
    setTimeout(() => {      
      $(this).scrollTop(0);
    },100)
  }
  
  $('.standard-options-cont .variant-wrapper select').each(function() {
    $(this).find('option').removeAttr('selected');
    $(this).find('option:first-child').attr('selected', 'selected');
    var vv = $(this).find('option:first-child').val();
    $(this).val(vv);
    $(this).change();
  });
  $('.standard-options-cont .variant-wrapper select').css('opacity', '1');
  
  var vluesselected1 = $('.tempsuffix-product-custom #first_available_selected_variant').attr('first');
  var vluesselected2 = $('.tempsuffix-product-custom #first_available_selected_variant').attr('second');
  var vluesselected3 = $('.tempsuffix-product-custom #first_available_selected_variant').attr('third');

  $('.tempsuffix-product-custom .variant-wrapper.elevate-index-1').find('select').val(vluesselected1).change();
  $('.tempsuffix-product-custom .variant-wrapper.elevate-index-2').find('select').val(vluesselected2).change();
  $('.tempsuffix-product-custom .variant-wrapper.elevate-index-3').find('select').val(vluesselected3).change();
  
  $('.clarks-golf-centre').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    lazyLoad:true,
    autoplay: true,
    stagePadding: 40,
    loop:true,
    items:1
  });
  
  $('.related_product').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    autoplay: true,
    loop:true,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:2
      },
      1000:{
        items:4
      }
    }
  });

  $('.owl-carousel-featured-product').owlCarousel({
    margin:10,
    nav:true,
    dots:false,
    lazyLoad:false,
    autoplay: false,
    stagePadding: 50,
    loop:false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:4
      }
    }
  });
  $('.rel-using-tags').owlCarousel({
    margin:10,
    nav:true,
    dots:false,
    lazyLoad:false,
    autoplay: false,
    stagePadding: 50,
    loop:false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:4
      }
    }
  });

  $('.arne-color-swatch-containers.owl-carousel').owlCarousel({
    margin:10,
    nav:true,
    dots:false,
    autoplay: false,
    stagePadding: 50,
    loop:false,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:3
      },
      1000:{
        items:4
      }
    }
  });
  
  $('.product-pair-with-wrap').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    lazyLoad:true,
    autoplay: true,
    loop:false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
        $('.blogs_grid_wrapper').owlCarousel({
          nav:false,
          dots:false,
          lazyLoad:true,
          autoplay: false,
          loop:false,
          margin: 16,
          stagePadding: 50,
          responsive:{
            0:{
              items:1
            },
            600:{
              items:2
            },
            1000:{
              items:3
            }
          }
        });
  
    function checkScreenSize(){
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 768) {
        $('.fitting_popup_innerwrapper').addClass('owl-carousel');
        $('.fitting_popup_innerwrapper').owlCarousel({
          nav:false,
          dots:true,
          lazyLoad:true,
          autoplay: true,
          loop:false,
          items:1
        });

        $('.mutli_blocks').addClass('owl-carousel');
        $('.mutli_blocks').owlCarousel({
          nav:false,
          dots:false,
          lazyLoad:true,
          autoplay: false,
          loop:false,
          items:1,
          margin: 16,
          stagePadding: 50
        });
      }
    }
  
  
  $('.rel-using-tags .owl-nav button').html('<img src="https://cdn.shopify.com/s/files/1/0601/7459/8330/files/righticon.svg?v=1683747848" />');

  $('button.tb').click(function(){
    $('.tabab').removeClass('active');
    $(this).parent('.tabab').addClass('active');
    var currentsec = $(this).attr('data-id');
    var otherid = $(this).attr('other-id');
    $('#'+otherid).hide();
    $('#'+currentsec).fadeIn(100);
  });

  $('.actions-toggle-refine').click(function(e) {
    e.preventDefault();
    $('.template-collection .boost-pfs-filter-left-col').toggleClass('active');
    $('.template-collection .boost-pfs-filter-right-col').toggleClass('active');
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $(this).find('span').html($(this).attr('data-button-text-hide'))
    } else {
      $(this).find('span').html($(this).attr('data-button-text-show'))
    }
  });

  $('.tab-custom-stan-option .tablinks').click(function(e) {
    e.preventDefault();
    var atr = $(this).attr('data-attr');
    $('.tab-custom-stan-option .tablinks').removeClass('active');
    $(this).addClass('active');
    if (atr == 'custom-options') {
      $('#sel-custom-options').html($('#customoptions').html());
      var v = '';
      
      $('.standard-options-cont .variant-wrapper select').each(function() {
      	$(this).find('option').removeAttr('selected');
        $(this).find('option[value="custom"]').attr('selected', 'selected');
        $(this).val('custom');
        $(this).siblings('.dropdown').find('li[datavalue="custom"]').click();
        $(this).siblings('.dropdown').find('.current').attr('vvalue', 'custom');
        $(this).change();
      });

      
      $('.variant-wrapper.elevate-index-1').find('.dropdown .current').text('custom');
      $('.variant-wrapper.elevate-index-1').find('.dropdown .current').attr('vvalue', 'custom');
      $('.variant-wrapper.elevate-index-1').find('.dropdown li[datavalue="custom"]').click();
      
      $('.variant-wrapper.elevate-index-2').find('.dropdown .current').text('custom');
      $('.variant-wrapper.elevate-index-2').find('.dropdown .current').attr('vvalue', 'custom');
      $('.variant-wrapper.elevate-index-2').find('.dropdown li[datavalue="custom"]').click();
      
      $('.variant-wrapper.elevate-index-3').find('.dropdown .current').text('custom');
      $('.variant-wrapper.elevate-index-3').find('.dropdown .current').attr('vvalue', 'custom');
      $('.variant-wrapper.elevate-index-3').find('.dropdown li[datavalue="custom"]').click();
      
      $('.product-single__vendor.stock-track-status').css('opacity', '0');
      $('.custom-options-cont select').trigger('change');
      $('#orderdeadline').hide();
      $('#dynamicbuttonwrp').hide();
      $('.add-to-cart').removeAttr('disabled');
    } else {
      $('.product-single__vendor.stock-track-status').css('opacity', '1');
      $('#sel-custom-options').html('');
      $('select.product-single__variants option').removeAttr('selected');
      $('.standard-options select option:first-child').trigger('change');
      $('select.product-single__variants option:first-child').attr('selected', 'selected');
      $('.tempsuffix-product-custom .product__price').text('£'+parseInt($('#hiddenprice').val()).toFixed(2));
      $('select.product-single__variants').trigger('change');
      $('.custom-options').each(function() {
        $(this).find('select').val($(this).find('select').find('option:first-child').val());
      });

      var vluesselected1 = $('#first_available_selected_variant').attr('first');
      var vluesselected2 = $('#first_available_selected_variant').attr('second');
      var vluesselected3 = $('#first_available_selected_variant').attr('third');
      
      $('.variant-wrapper').each(function(i, v) {
        $(this).find('select').val($(this).find('select').find('option:first-child').val()).change();
      });
      $('.variant-wrapper.elevate-index-1').find('select').val(vluesselected1).change();
      $('.variant-wrapper.elevate-index-2').find('select').val(vluesselected2).change();
      $('.variant-wrapper.elevate-index-3').find('select').val(vluesselected3).change();

      if (vluesselected1) {
        $('.variant-wrapper.elevate-index-1').find('.dropdown li[datavalue="'+vluesselected1+'"]').click();
        $('.variant-wrapper.elevate-index-1').find('.dropdown .current').text(vluesselected1);
        $('.variant-wrapper.elevate-index-1').find('.dropdown .current').attr('vvalue', vluesselected1);
      }
      if (vluesselected2) {
        $('.variant-wrapper.elevate-index-2').find('.dropdown li[datavalue="'+vluesselected2+'"]').click();
        $('.variant-wrapper.elevate-index-2').find('.dropdown .current').text(vluesselected2);
        $('.variant-wrapper.elevate-index-2').find('.dropdown .current').attr('vvalue', vluesselected2);
      }
      if (vluesselected3) {
        $('.variant-wrapper.elevate-index-3').find('.dropdown li[datavalue="'+vluesselected3+'"]').click();
        $('.variant-wrapper.elevate-index-3').find('.dropdown .current').text(vluesselected3);
        $('.variant-wrapper.elevate-index-3').find('.dropdown .current').attr('vvalue', vluesselected3);
      }
      
      $('#orderdeadline').show();
      $('#dynamicbuttonwrp').show();

      var scndselected2 = $('.cscst.elevate-index-2').find('.dropdown .current').text();
      var scndselected3 = $('.cscst.elevate-index-3').find('.dropdown .current').text();
      console.log(scndselected2, scndselected3)
      setTimeout(() => {
      if (scndselected2 == 'Select' || scndselected3 == 'Select') {
        $('.add-to-cart').attr('disabled', 'disabled');
      } else {
        $('.add-to-cart').removeAttr('disabled');
      }
      }, 25);
    }

    $('.tab-custom-stan-option .tabcontent').fadeOut(100);
    $('.tab-custom-stan-option .tabcontent').removeClass('active');
    $('.tab-custom-stan-option .tabcontent[data-attr="'+atr+'"]').addClass('active');
    $('.tab-custom-stan-option .tabcontent[data-attr="'+atr+'"]').fadeIn(100);
  });

  var $popup = $("[data-popup]");
  $(document).on('click', 'button.close-proceed', function(){
    $popup.slideUp(240); 
    $('body').removeClass('data-popup');
  });

 if ($('body').hasClass('pingpopup') && $('body').hasClass('template-product')) {
    var n = 1
    var $popup = n ? $("[data-popup='"+n+"']") : $(this).closest("[data-popup]");
    $popup.slideToggle(240);
    $('body').addClass('data-popup');
  }
  
  $(window).on('load', function(){
    setTimeout(() => {
    }, 2000);

    
      var vluesselected1 = $('.tempsuffix-product-custom #first_available_selected_variant').attr('first');
      var vluesselected2 = $('.tempsuffix-product-custom #first_available_selected_variant').attr('second');
      var vluesselected3 = $('.tempsuffix-product-custom #first_available_selected_variant').attr('third');

      $('.tempsuffix-product-custom .variant-wrapper.elevate-index-1').find('select').val(vluesselected1).change();
      $('.tempsuffix-product-custom .variant-wrapper.elevate-index-2').find('select').val(vluesselected2).change();
      $('.tempsuffix-product-custom .variant-wrapper.elevate-index-3').find('select').val(vluesselected3).change();
    
  });

  $('input[name="is_confirm"]').click(function(){
    if($(this).prop("checked") == true){
      $('.close-proceed').addClass('active');
      $('input[name="is_dynamic"]').prop( "checked", false );
      $('button.close-proceed.active').trigger('click');
    }
    else if($(this).prop("checked") == false){
      $('.close-proceed').removeClass('active');
    }
  });
  $('input[name="is_dynamic"]').click(function(){
    if($(this).prop("checked") == true){
      $('.close-proceed').addClass('active');
      $('input[name="is_confirm"]').prop( "checked", false );
      $('button.close-proceed.active').trigger('click');
    }
    else if($(this).prop("checked") == false){
      $('.close-proceed').removeClass('active');
    }
  });

  $(document).on('change', '.custom-options-cont select', function() {
    var cprice = $('#hiddenprice').val();
    var totalprice = cprice;
    $('.custom-options-cont select').each(function() {
      var price = $(this).find('option:selected').attr('vupgradeprice');
      if (!price) {
      	price = 0;
      }
      if (price > 0) {
        price = parseInt(price)/100;
      }
        totalprice = parseInt(totalprice) + parseInt(price);
      
    });
    $('.tempsuffix-product-custom .product-single__meta .product__price').text('£'+totalprice.toFixed(2) );
  $('.tempsuffix-custom-preorder .product-single__meta .product__price').text('£'+totalprice.toFixed(2) );
    
    if ($('.loyalty-rewards-point p .points-count').hasClass('triple')) {
      $('.loyalty-rewards-point p .points-count').text(Math.ceil(totalprice)*3);
    } else if ($('.loyalty-rewards-point p .points-count').hasClass('double')) {
      $('.loyalty-rewards-point p .points-count').text(Math.ceil(totalprice)*2);
    } else {
      $('.loyalty-rewards-point p .points-count').text(Math.ceil(totalprice));
    }
    
    if ($('.loyalty-rewards-point p .pointprice').hasClass('triple')) {
      $('.loyalty-rewards-point p .pointprice').text((Math.ceil(totalprice)/100)*3);
    } else if ($('.loyalty-rewards-point p .pointprice').hasClass('double')) {
      $('.loyalty-rewards-point p .pointprice').text((Math.ceil(totalprice)/100)*2);
    } else {
      $('.loyalty-rewards-point p .pointprice').text(Math.ceil(totalprice)/100);
    }

    if (totalprice <= 30000) {
      var deva = (totalprice / 3);
      var devac = (totalprice / 4);
      $('.dynamic_financers').html('£'+deva.toFixed(2));

      $('.dynamic_financers_clear').html('£'+devac.toFixed(2));
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
    }

  });

  $('.readmore').click(function (event) {
    event.preventDefault();
    // var descriptionFull = document.querySelector('.product-description-full');
    // descriptionFull.style.display = 'block';
    $(this).parents('.Rte').find('.product-description-full').show();
    $(this).parents('.Rte').find('.product-description-short').hide();
    // var descriptionShort = document.querySelector('.product-description-short');
    // descriptionShort.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    // var descriptionFull = document.querySelector('.product-description-full');
    // descriptionFull.style.display = 'none';
    // var descriptionShort = document.querySelector('.product-description-short');
    // descriptionShort.style.display = 'block';

    
    $(this).parents('.Rte').find('.product-description-full').hide();
    $(this).parents('.Rte').find('.product-description-short').show();
  });  
});

$(window).on('load', function () {
    
  $('.related_product').owlCarousel({
    margin:10,
    nav:true,
    dots:false,
    autoplay: true,
    loop:true,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:2
      },
      1000:{
        items:4
      }
    }
  });
  

  $('.standard-options-cont .variant-wrapper select').each(function() {
    $(this).find('option').removeAttr('selected');
    $(this).find('option:first-child').attr('selected', 'selected');
    var vv = $(this).find('option:first-child').val();
    $(this).val(vv);
    $(this).change();
  });
  $('.standard-options-cont .variant-wrapper select').css('opacity', '1');
  $('.tablinks').removeAttr('disabled');
  if ($('body').hasClass('pingpopup')) {
    $('.tablinks[data-attr="custom-options"]').trigger('click');
    $('.add-to-cart').removeAttr('disabled');
  }
  
  $('.elevate-index-1 select').change();

  if($('#standard-option-hidden').val() == 'true') {
    $('.tablinks[data-attr="custom-options"]').trigger('click');
    $('.add-to-cart').removeAttr('disabled');
  }
  setTimeout(() => { 
    if ($('body').hasClass('pingpopup')) {
      $('.tablinks[data-attr="custom-options"]').trigger('click');
      $('.add-to-cart').removeAttr('disabled');
    }
  }, 20);
});

$(document).ready(function() {
  $('.owl-next-custom').click(function() {
  	$(this).parents('.index-section').find('.owl-next').trigger('click');
  });

  $('.owl-prev-custom').click(function() {
  	$(this).parents('.index-section').find('.owl-prev').trigger('click');
  });
  
  $('.elevate-index-1 select').change();

  // $('.elev_wrapper-1 .variant-input').click(function() {
  //   setTimeout(() => { 
  //       $('.elev_wrapper-2 .variant-input').each(function() {
  //         if (!($(this).find('label').hasClass('disabled'))) {
  //           $(this).find('label').trigger('click');
  //           return false;
  //         }
  //       });

  //       $('.elev_wrapper-3 .variant-input').each(function() {
  //         if (!($(this).find('label').hasClass('disabled'))) {
  //           $(this).find('label').trigger('click');
  //           return false;
  //         }
  //       });
  //   }, 10)
  // });

  
  $('.elev_wrapper-1 .variant-input').click(function() {
    // if ($('body').hasClass('tempsuffix-')) { } else {
    setTimeout(() => { 
        $('.elev_wrapper-2 .variant-input').each(function() {
          // if ($('body').hasClass('type-Shoes')) {
            if (!($(this).hasClass('disabledv'))) {
              $(this).find('label').trigger('click');
              return false;
            }            
          // } else {
          //   if (!($(this).find('label').hasClass('disabled'))) {
          //     $(this).find('label').trigger('click');
          //     return false;
          //   }
          // }
        });

        $('.elev_wrapper-3 .variant-input').each(function() {
          // if ($('body').hasClass('type-Shoes')) {
            if (!($(this).hasClass('disabledv'))) {
              $(this).find('label').trigger('click');
              return false;
            }
          // } else {            
          //   if (!($(this).find('label').hasClass('disabled'))) {
          //     $(this).find('label').trigger('click');
          //     return false;
          //   }
          // }
        });
    }, 10)
    // }
  });

  $('.index-ref .readmore').click(function (event) {
    event.preventDefault();
    $(this).parents('.index-ref').find('.product-description-full').show();
    $(this).parents('.index-ref').find('.product-description-short').hide();
  });
  $('.index-ref .readless').click(function (event) {
    event.preventDefault();
    $(this).parents('.index-ref').find('.product-description-full').hide();
    $(this).parents('.index-ref').find('.product-description-short').show();
  });

  $('button.searchcstm-btn').click(function() {
    $(this).hide();
    $('.menudesktop').hide();
    $('.searchdesktop').fadeIn(100);
  });

  $('span.crosssearchbar').click(function() {
    $('button.searchcstm-btn').show();
    $('.menudesktop').show();
    $('.searchdesktop').hide();
  });
  
  $('a.readmorereadless').click(function() {
    $(this).toggleClass('active');
    $('.readmorereadless .rte').toggle();
    if ($(this).hasClass('active')) {
      $(this).html('Read less');
    } else {
      $(this).html('Read more');
    }
  });
});

function create_custom_dropdowns() {
  $('.cscst select').each(function(i, select) {
    var parentThis = $(this);
    if (!$(this).next().hasClass('dropdown')) {
      $(this).after('<div class="dropdown ' + ($(this).attr('classes') || '') + '" tabindex="0"><span class="current" vvalue=""></span><div class="list"><ul></ul></div></div>');
      var dropdown = $(this).next();
      var options = $(select).find('option');
      var selected = $(this).find('option:selected');
      dropdown.find('.current').html(selected.attr('display-text') || selected.text() || 'Select');
      var a = (selected.attr('display-text')) || (selected.text()) || 'Select';
      dropdown.find('.current').attr('vvalue', a);
      
      options.each(function(j, o) {
        var classs = $(this).attr('class');
        classs = classs.replace('variant-input', '');
        if (parentThis.parents('.cscst').hasClass('elevate-index-1')) {
          classs = classs.replace('disabled', '');
        }
        // classs = '';
        classs = classs + ' i'+j+'index ';
        var display = $(o).data('display-text') || '';
        var dv = " datavalue='" + ($(o).val()).replace("'", '') + "' ";
        dropdown.find('ul').append('<li'+dv+' class="option ' +classs+' '+ ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + ($(o).val()) + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
      });
    }
  });

  $('.cscst.elevate-index-1 li.option.aba.i0index').trigger('click');
  $('.cscst.elevate-index-1 li.option.aba.i0index').trigger('click');
}
// Event listeners

// Open/close
$(document).on('click', '.cscst .dropdown', function(event) {
  $('.cscst .dropdown').not($(this)).removeClass('open');
  $(this).toggleClass('open');
  if ($(this).hasClass('open')) {
    $(this).find('.option').attr('tabindex', 0);
    $(this).find('.selected').focus();
  } else {
    $(this).find('.option').removeAttr('tabindex');
    $(this).focus();
  }
});

// Close when clicking outside
$(document).on('click', function(event) {
  if ($(event.target).closest('.dropdown').length === 0) {
    $('.dropdown').removeClass('open');
    $('.dropdown .option').removeAttr('tabindex');
  }
  event.stopPropagation();
});

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
// Option click
$(document).on('click', '.cscst .dropdown .option', function(event) {
  if($(this).hasClass('disabled') || $(this).hasClass('notavailableatall')) {} else {
    if ($(this).parents('.cscst').hasClass('elevate-index-1') || 
        $(this).parents('.cscst').hasClass('elevate-index-2')) {
      $('.add-to-cart').addClass('disabled');
      $('.add-to-cart').attr('disabled', true);
    }
    
     if ($(this).parents('.cscst').hasClass('elevate-index-3')) {
       var scndselected = $('.cscst.elevate-index-2').find('.dropdown .current').text();
       if (scndselected == 'Select') {
         $('.selectionerrormsg').html('Please select step 2 first');
         setTimeout(function() {
           $('.selectionerrormsg').html('&nbsp;');
         }, 1500);
         return;
       }
     }
    
    
    $(this).closest('.list').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var text = $(this).data('display-text') || $(this).text();
    $(this).closest('.dropdown').find('.current').text(text);
    var tvalue = $(this).attr('datavalue');
    tvalue = tvalue.trim();
    // console.log("tvaluetvaluetvalue", tvalue)
    // $(this).closest('.dropdown').prev('select').val($(this).data('datavalue')).trigger('change');
    $(this).closest('.dropdown').prev('select').find('option').removeAttr('selected');
    
    $(this).closest('.dropdown').prev('select').find("option[value='"+tvalue+"']").attr('selected', 'selected');
    $(this).closest('.dropdown').prev('select').val(tvalue).trigger('change');
    $(this).closest('.dropdown').prev('select').val(tvalue).change();
          
    $(this).closest('.dropdown').prev('select').find("option[davalue='"+tvalue+"']").attr('selected', 'selected');
    $(this).closest('.dropdown').prev('select').trigger('change');
    // $(this).closest('.dropdown').prev('select').change();
      
    var lisize = $(this).parent().find('li').length;
    lisize = parseInt(lisize); 
    var thatparent = $(this);
    
    // if ($(this).parents('.cscst').hasClass('elevate-index-1')) {
    //   $('.add-to-cart').addClass('disabled');
    //   $('.add-to-cart').attr('disabled', true);
    //   // if (!$(this).parents('.cscst').hasClass('elevate-index-2')) {
    //     $('.cscst.elevate-index-2').find('.current').html('Select');
    //   // }
    //   $('.cscst.elevate-index-3').find('.current').html('Select');

      
    //   var optn1 = [], optn2 = [], optn3 = [];
    //   $('.customvariants_status option.disabledvariants').each(function() {
    //     var atr = $(this).attr('dataval');
    //     var optionsize = $(this).attr('size');
    //     var splitedatr = atr.split(' / ');
    //     if (optionsize == 3) {
    //       optn1.push(splitedatr[0]);
    //       optn2.push(splitedatr[1]);
    //       optn3.push(splitedatr[2]);
    //     }
    //     if (optionsize == 2) {
    //       optn1.push(splitedatr[0]);
    //       optn2.push(splitedatr[1]);
    //     }
    //   });
    //   var optn1unique = optn1.filter(onlyUnique);
    //   var optn2unique = optn2.filter(onlyUnique);
    //   var optn3unique = optn3.filter(onlyUnique);
      
    //   // console.log(optn1, optn2, optn3)
    
    //   setTimeout(function() {
    //           // console.log(optn1, optn2, optn3)
    //     $('.cscst').find('.dropdown').find('ul li').removeClass('disabled');
    //     // $('.cscst').each(function() {
    //       // if (!$(this).hasClass('elevate-index-1')) {
    //       //   $(this).find('select').find('option').each(function() {
    //       //     var v = $(this).val();
    //       //     var dis = $(this).attr('disabled');
              
    //       //     $(this).parent().siblings('.dropdown').find('ul li').each(function() {
    //       //       var vv = $(this).attr('data-value');
                
    //       //       // console.log(diss, dis, '---------------')
    //       //       if (v == vv) {
    //       //         if (dis) {
    //       //           $(this).addClass('disabled');
    //       //         }
    //       //       }
    //       //     })
    //       //   });
    //       // }

    //       // $('.cscst').each(function() {
    //         // if (!$(this).hasClass('elevate-index-1')) {
    //           // $('.cscst.elevate-index-1').find('.dropdown').find('ul li').each(function() {
    //             // var vvv = $(this).attr('data-value');
    //             optn1.forEach(function(v, i) {
    //               console.log(text, v)
    //               v = v.trim();
    //               text = text.trim();
    //               optn2[i] = optn2[i].trim();
    //               optn3[i] = optn3[i].trim();
    //               if (text == v) {
    //                 $('.cscst.elevate-index-2').find('.dropdown').find('ul li[data-value="'+optn2[i]+'"]').addClass('disabled');

    //                 // if ($('.cscst.elevate-index-2').find('.dropdown .current').text() != 'Select') {
    //                 //   $('.cscst.elevate-index-3').find('.dropdown').find('ul li[data-value="'+optn3[i]+'"]').addClass('disabled');
    //                 // }
    //                 // $('.cscst.elevate-index-2').find('.dropdown').find('ul li').each(function() {
    //                 //   var vin = $(this).attr('data-value');   
    //                 //   vin = vin.trim();
    //                 //   optn2[i] = optn2[i].trim();
    //                 //   if (vin == optn2[i]) {
    //                 //     $(this).addClass('disabled');
    //                 //   }
    //                 // });
    //                 // $('.cscst.elevate-index-3').find('.dropdown').find('ul li').each(function() {
    //                 //   var vin = $(this).attr('data-value');    
    //                 //   vin = vin.trim();
    //                 //   optn3[i] = optn3[i].trim();
    //                 //   console.log('-------------', vin, optn3[i], '#####')
    //                 //   if (vin == optn3[i]) {
    //                 //     console.log('ininininin')
    //                 //     $(this).addClass('disabled');
    //                 //   }
    //                 // });
    //               }
    //             })
    //           // });
    //         // }
    //       // });

          
    //       // if ($(this).hasClass('elevate-index-2')) {
    //       //   $(this).find('.dropdown').find('ul li').each(function() {
    //       //     var v = $(this).val();
    //       //     if (optn2unique.includes(v)) {
    //       //       $(this).addClass('disabled');
    //       //     }
    //       //   });
    //       // }
    //       // if ($(this).hasClass('elevate-index-3')) {
    //       //   $(this).find('.dropdown').find('ul li').each(function() {
    //       //     var v = $(this).val();
    //       //     if (optn3unique.includes(v)) {
    //       //       $(this).addClass('disabled');
    //       //     }
    //       //   });
    //       // }
          
    //     // });
    //   }, 100);
    // }
    // if ($(this).parents('.cscst').hasClass('elevate-index-1') || 
    //     $(this).parents('.cscst').hasClass('elevate-index-2')) {
    //   $('.add-to-cart').addClass('disabled');
    //   $('.add-to-cart').attr('disabled', true);
    // }
    
    if ($(this).parents('.cscst').hasClass('elevate-index-1')) {
      $('.cscst.elevate-index-2').find('.current').html('Select');
      $('.cscst.elevate-index-2').find('.ul li').addClass('disabled');
      
      $('.cscst.elevate-index-3').find('.current').html('Select');
      $('.cscst.elevate-index-3').find('.ul li').addClass('disabled');
      
      var optn1 = [], optn2 = [], optn3 = [];
      $('.customvariants_status option.availablevariants').each(function() {
        var atr = $(this).attr('dataval');
        var optionsize = $(this).attr('size');
        var splitedatr = atr.split(' / ');
        if (optionsize == 3) {
          optn1.push(splitedatr[0]);
          optn2.push(splitedatr[1]);
          optn3.push(splitedatr[2]);
        }
        if (optionsize == 2) {
          optn1.push(splitedatr[0]);
          optn2.push(splitedatr[1]);
        }
      });
      
      setTimeout(function() {
        // console.log(optn1, optn2, optn3)
        $('.cscst.elevate-index-2').find('.dropdown').find('ul li').addClass('disabled');
        $('.cscst.elevate-index-3').find('.dropdown').find('ul li').addClass('disabled');
          optn1.forEach(function(v, i) {
            v = v.trim();
            var textinit = $('.cscst.elevate-index-1').find('.dropdown .current').text();
            textinit = textinit.trim();
            if (optn2[i]) {
              optn2[i] = optn2[i].trim();
            }
            if (optn3[i]) {
              optn3[i] = optn3[i].trim();
            }
            // console.log('fsfdsfdsfd', textinit, v)
            if (textinit == v) {              
              $('.cscst.elevate-index-2').find('.dropdown').find('ul li[data-value="'+optn2[i]+'"]').removeClass('disabled');
              $('.cscst.elevate-index-3').find('.dropdown').find('ul li[data-value="'+optn3[i]+'"]').removeClass('disabled');
              
              $('.cscst.elevate-index-2').find('.dropdown').find('ul li[datavalue="'+optn2[i]+'"]').removeClass('disabled');
              $('.cscst.elevate-index-3').find('.dropdown').find('ul li[datavalue="'+optn3[i]+'"]').removeClass('disabled');
            }            
          })
      }, 100);
    }
    
    if ($(this).parents('.cscst').hasClass('elevate-index-2') && lisize > 2) {
      $('.cscst.elevate-index-3').find('.current').html('Select');
      $('.cscst.elevate-index-3').find('.ul li').addClass('disabled');
      var scndselected = $('.cscst.elevate-index-2').find('.dropdown .current').text();
      scndselected = scndselected.trim();
      scndselected = scndselected.replace('"', '');
      scndselected = scndselected.replace("'", '');
      
      var optn1 = [], optn2 = [], optn3 = [];
      $('.customvariants_status option.availablevariants').each(function() {
        var atr = $(this).attr('dataval');
        var optionsize = $(this).attr('size');
        var splitedatr = atr.split(' / ');
        if (optionsize == 3) {
          optn1.push(splitedatr[0]);
          optn2.push(splitedatr[1]);
          optn3.push(splitedatr[2]);
        }
        if (optionsize == 2) {
          optn1.push(splitedatr[0]);
          optn2.push(splitedatr[1]);
        }
      });
      
      setTimeout(function() {
        // console.log(optn1, optn2, optn3)
        $('.cscst.elevate-index-3').find('.dropdown').find('ul li').addClass('disabled');
          optn1.forEach(function(v, i) {
            v = v.trim();
            var textinit = $('.cscst.elevate-index-1').find('.dropdown .current').text();
            textinit = textinit.trim();
            if (optn2[i]) {
              optn2[i] = optn2[i].trim();
              optn2[i] = optn2[i].replace("'", '');
            }
            if (optn3[i]) {
              optn3[i] = optn3[i].trim();
              optn3[i] = optn3[i].replace("'", '');
            }
            // console.log(textinit, v, scndselected, optn2[i])
            if (textinit == v && scndselected == optn2[i]) {
              $('.cscst.elevate-index-3').find('.dropdown').find('ul li[data-value="'+optn3[i]+'"]').removeClass('disabled');
              
              $('.cscst.elevate-index-3').find('.dropdown').find('ul li[datavalue="'+optn3[i]+'"]').removeClass('disabled');
            }
          })
      }, 100);
    }
  }
});

// Keyboard events
$(document).on('keydown', '.cscst .dropdown', function(event) {
  var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
  // Space or Enter
  if (event.keyCode == 32 || event.keyCode == 13) {
    if ($(this).hasClass('open')) {
      focused_option.trigger('click');
    } else {
      $(this).trigger('click');
    }
    return false;
    // Down
  } else if (event.keyCode == 40) {
    if (!$(this).hasClass('open')) {
      $(this).trigger('click');
    } else {
      focused_option.next().focus();
    }
    return false;
    // Up
  } else if (event.keyCode == 38) {
    if (!$(this).hasClass('open')) {
      $(this).trigger('click');
    } else {
      var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
      focused_option.prev().focus();
    }
    return false;
  // Esc
  } else if (event.keyCode == 27) {
    if ($(this).hasClass('open')) {
      $(this).trigger('click');
    }
    return false;
  }
});

$(document).ready(function() {
  create_custom_dropdowns();
  $('.vavailable-true[data-index="option1"].vindex0 label').trigger('click')
});

